import React from 'react';

export const HorizontalSpacer = () => (
    <div className="mx-2 border-got-dark border-b opacity-25" />
);
